import type { FC } from 'react';
import sectionStyles from '../../SubsCancellationReasonsSection.scss';

export interface Props {
  percentage: number | null;
  className?: string;
}

const ReasonProgressBar: FC<Props> = ({ percentage, className }) => {
  const containerClassName = className
    ? `${sectionStyles['reason-info']} ${className}`
    : sectionStyles['reason-info'];

  return (
    <div className={containerClassName}>
      <div className={sectionStyles['progress-bar']}>
        <div
          className={sectionStyles['progress-fill']}
          style={{ width: percentage !== null ? `${percentage}%` : '0%' }}
        />
        <div className={sectionStyles['progress-background']} />
      </div>
      <span className={sectionStyles['reason-percentage']}>
        {percentage !== null ? `${percentage}%` : 'N/A'}
      </span>
    </div>
  );
};

ReasonProgressBar.displayName = 'ReasonProgressBar';

export default ReasonProgressBar;
